module.exports = __webpack_public_path__ + "static/media/bg4.0ce4d4c0.jpg";